<svelte:options accessors/>
<script>
    import NauiExplorer from "../../../naui/pages/NauiExplorer.svelte";
    import NauiSelect from "../../../naui/atoms/NauiSelect.svelte";
    import {createEventDispatcher, onMount} from "svelte";
    import {getFormatter} from "../../../utils";

    let dispatch = createEventDispatcher();
    let format = getFormatter();

    export let columns;
    export let options;
    export let data;
    export let month;

    onMount(() => {
        calcTotals();
    });

    export function calcTotals() {
        // Suma de totales de la tabla - el join de base de datos no da el total esperado.
        const last = data[data.length - 1];

        const keys = ['ventas', 'visualizacion', 'total_esperado', 'presupuesto'];

        for (const item of data) {
            if (item === last) continue;
            for (const key of keys) {
                last[key] += item[key];
                item[key] = format(item[key])
            }
        }
        if (last.presupuesto) {
            last.porcentaje_cumplimiento = ((last.total_esperado * 100) / (last.presupuesto * 100)) * 100;
            last.porcentaje_cumplimiento = last.porcentaje_cumplimiento.toFixed(2) + '%';
        } else {
            last.porcentaje_cumplimiento = 'N/A';
        }
        for (const key of keys) {
            last[key] = format(last[key]);
        }
        data = data;
    }
</script>

<div>
    <div class="pt-15">
        <div class="grid-4 gap-15">
            <NauiSelect label="Mes"
                        bind:value={month} options={options.months}
                        on:change={() => {dispatch('month', {month})}}/>
        </div>
    </div>
    <NauiExplorer {data} {columns} hideSearch={true} paginate={false}/>
</div>